export default "__VITE_ASSET__16783af0__"